import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export type MonthlyStatisticsResponse = {
  success: boolean;
  data: MonthlyStatisticsData;
};

export type MonthlyStatisticsData = {
  year: number;
  monthlyData: MonthlyDatum[];
};

export type MonthlyDatum = {
  month: number;
  year: number;
  workingHours: number;
  employeeProgress: number;
};

const getYearlyStatistics = async (userId?: string): Promise<MonthlyStatisticsResponse> => {
  const params = new URLSearchParams();
  if (userId) {
    params.append('userId', userId);
  }
  const { data } = await customAxios.get<MonthlyStatisticsResponse>(
    `/attendance/dashboard/yearly-status${params.toString() ? `?${params.toString()}` : ''}`
  );

  return data;
};

export const useGetYearlyStatistics = (userId?: string) =>
  useQuery<MonthlyStatisticsResponse, AxiosError>(
    ["year-statistics", userId],
    () => getYearlyStatistics(userId),

    {
      onError: (error) =>
        showNotification({
          title: "Error Loading Yearly Stats",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Something went wrong",
          color: "red",
        }),
      staleTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnMount: "always",
    }
  );
